import { AuthServiceProviderV2, AuthServiceEventV2, } from '../v2/AuthServiceProviderV2';
export { AuthServiceEventV2 as AuthServiceEventV1 };
export class AuthServiceProviderV1 extends AuthServiceProviderV2 {
    loginAll(prompt, redirectUrl) {
        // IDSSO was the default IDP until feature service version 2.0.0
        super.loginAll(prompt, redirectUrl, { idsso: true });
    }
}
//# sourceMappingURL=AuthServiceProviderV1.js.map